webpackJsonp([18,26,41],{

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = checkIntersection;
function checkIntersection($el, callback) {
  var $scrollListener = document.querySelector('.scroll-listener');
  var observerActive = false;

  function onScrollUpdate() {
    if (observerActive === false) {
      observerActive = true;

      setTimeout(function () {
        if ($el.getBoundingClientRect().top < window.innerHeight && $el.getBoundingClientRect().bottom >= 0 && $el.clientWidth > 0 && $el.clientHeight > 0) {
          callback();
          $scrollListener.Component['scroll-listener'].removeObserver(onScrollUpdate);
        }

        observerActive = false;
      }, 200);
    }
  }

  onScrollUpdate();

  $scrollListener.Component['scroll-listener'].addObserver(onScrollUpdate);
}

/***/ }),

/***/ 178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_build_component__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_check_intersection__ = __webpack_require__(171);



/* harmony default export */ __webpack_exports__["default"] = (function (nameSpace, selector) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_build_component__["default"])({
    nameSpace: nameSpace,
    selector: selector,
    initState: {
      isInView: false
    },
    initFunction: function initFunction($el, params) {
      var slider = void 0;

      //
      // Methods
      //

      function initSlider() {
        __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 510)).then(function (module) {
          var Swiper = module.default;
          slider = new Swiper($el.querySelector('.swiper-container'), params.swiperConfig);
        });
      }

      //
      // Life Cycle
      //

      params.onStateUpdate(function (newState, prevState) {
        if (!prevState.isInView && newState.isInView) {
          initSlider();
        }
      });

      //
      // Procedures
      //

      Object(__WEBPACK_IMPORTED_MODULE_1__utils_check_intersection__["default"])($el, function () {
        params.setState({ isInView: true });
      });

      //
      // Public API
      //

      return {
        get swiperInstance() {
          return slider;
        }
      };
    }
  });
});

/***/ }),

/***/ 214:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_build_component__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slider__ = __webpack_require__(178);



/* harmony default export */ __webpack_exports__["default"] = (function (nameSpace, selector) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_build_component__["default"])({
    nameSpace: nameSpace,
    selector: selector,
    initFunction: function initFunction($el, params) {
      var sliderComponent = void 0;
      var $buttonPrev = $el.querySelector('.' + nameSpace + '__button-prev');
      var $buttonNext = $el.querySelector('.' + nameSpace + '__button-next');
      var slideToTimeout = void 0;

      //
      // Methods
      //

      function onReachEnd() {
        var swi = sliderComponent.swiperInstance;
        if (slideToTimeout) {
          clearTimeout(slideToTimeout);
        }
        slideToTimeout = setTimeout(function () {
          return swi.slideTo(0);
        }, 3000);
      }

      function onSlideChange() {
        if (slideToTimeout) {
          clearTimeout(slideToTimeout);
        }
      }

      //
      // Life Cycle
      //

      //
      // Procedures
      //

      sliderComponent = Object(__WEBPACK_IMPORTED_MODULE_1__slider__["default"])(nameSpace).init({
        $el: $el,
        customParams: {
          swiperConfig: {
            autoplay: true,
            slidesPerView: 'auto',
            on: {
              reachEnd: onReachEnd,
              slideChange: onSlideChange
            },
            navigation: {
              prevEl: $buttonPrev,
              nextEl: $buttonNext
            }
          }
        }
      });

      //
      // Listeners / Observers
      //

      //
      // Public API
      //

      return {};
    }
  });
});

/***/ })

});


// WEBPACK FOOTER //
// js/chunk-pages-slider.bundle.js